/**
 * Poly Hydration — Configuration
 *
 * Build-time and runtime configuration for the hydration module.
 */

// Build-time flag: replaced by Vite's `define` config (see vite.config.hydration.ts).
// Production IIFE bundle: statically false with a runtime URLSearchParams check
// Local dev / vitest: true (NODE_ENV is 'development' or 'test').
// Future stage-specific builds can set NODE_ENV via the `define` block to control this per environment.
const BUILD_DEBUG = process.env.NODE_ENV !== 'production';

// Runtime override: allows opting in to debug logging in production contexts
// via query parameter ?hydrationDebug=true. Useful for field debugging without
// redeploying a debug bundle. Only checked once at module load time.
function checkRuntimeDebug(): boolean {
  try {
    if (typeof window !== 'undefined' && window.location?.search) {
      return new URLSearchParams(window.location.search).get('hydrationDebug') === 'true';
    }
  } catch {
    // SSR or restricted environment — ignore
  }
  return false;
}

export const DEBUG = BUILD_DEBUG || checkRuntimeDebug();
